// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgCompareBarsIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M21 19h-1V4c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1h5v14h-2V8c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1s.45 1 1 1h5v10h-2v-7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v7H3c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1" />
  </g>
);
export default SvgCompareBarsIcon;
SvgCompareBarsIcon.displayName = 'SvgCompareBarsIcon';
